/**
 * Runtime configuration, read from Vite environment variables at build time.
 * Every value is optional: without any key the game runs on Panoramax + OpenStreetMap data.
 *
 * Note: browser keys (Google Maps, Mapillary client token) always end up in the
 * built JavaScript. They are not secrets, so restrict them by HTTP referrer in the provider console.
 */

function env(value: string | undefined): string {
  return (value ?? '').trim();
}

export interface TileLayerConfig {
  url: string;
  attribution: string;
  subdomains?: string;
  maxZoom: number;
}

const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>';

/** Tile layers tried in order for the Leaflet guess map. The next one is used if the previous fails to load. */
export const TILE_LAYERS: TileLayerConfig[] = [
  ...(env(import.meta.env.VITE_MAP_TILE_URL)
    ? [
        {
          url: env(import.meta.env.VITE_MAP_TILE_URL),
          attribution: env(import.meta.env.VITE_MAP_TILE_ATTRIBUTION) || OSM_ATTRIBUTION,
          maxZoom: 19,
        },
      ]
    : []),
  // Keyless OpenStreetMap tiles. (CARTO basemaps now require an API key.)
  {
    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: OSM_ATTRIBUTION,
    maxZoom: 19,
  },
  {
    url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
    attribution: `${OSM_ATTRIBUTION} · tuiles <a href="https://www.openstreetmap.fr" target="_blank" rel="noopener">OpenStreetMap France</a>`,
    subdomains: 'abc',
    maxZoom: 19,
  },
];

export const config = {
  googleMapsApiKey: env(import.meta.env.VITE_GOOGLE_MAPS_API_KEY),
  mapillaryAccessToken: env(import.meta.env.VITE_MAPILLARY_ACCESS_TOKEN),
  panoramaxApiUrl: env(import.meta.env.VITE_PANORAMAX_API_URL).replace(/\/+$/, '') || 'https://explore.panoramax.fr/api',
  defaultProvider: env(import.meta.env.VITE_DEFAULT_PROVIDER),
};
